import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const MyCustomerSVG = ({ ...props }) => {
  return (
    <Svg
      width={49}
      height={48}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2605)">
        <Rect x={0.666748} width={48} height={48} rx={8} fill="#E8F1FF" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.825 48.32H26.49c.396 0 .737-.16.98-.46.242-.3.319-.657.22-1.025-1.207-4.497-5.465-7.82-10.532-7.82s-9.325 3.323-10.532 7.82c-.099.368-.022.724.22 1.024.243.3.584.46.98.46z"
          fill="url(#paint0_radial_103_2605)"
        />
        <Path
          d="M23.008 33.699a5.433 5.433 0 10-10.85-.598 5.433 5.433 0 0010.85.598z"
          fill="url(#paint1_radial_103_2605)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.731 48.032h22.736c.482 0 .898-.194 1.193-.558.296-.363.39-.795.27-1.24-1.471-5.448-6.658-9.473-12.83-9.473-6.174 0-11.36 4.025-12.83 9.473-.121.445-.027.877.268 1.24.296.364.71.558 1.193.558z"
          fill="url(#paint2_linear_103_2605)"
        />
        <Path
          d="M37.969 30.05a6.595 6.595 0 10-13.17-.725 6.595 6.595 0 0013.17.725z"
          fill="#84B9FB"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2605"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(154.869 7.783 22.502) scale(20.5363 13.7924)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2605"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(46.318 -27.894 29.92) scale(13.9639 12.1708)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <LinearGradient
          id="paint2_linear_103_2605"
          x1={31.0992}
          y1={36.7611}
          x2={31.0992}
          y2={48.0319}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <ClipPath id="clip0_103_2605">
          <Rect x={0.666748} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default MyCustomerSVG
